export var FILE_STORAGE_REPOSITORY = 'FILE_STORAGE_REPOSITORY';